<template>
    <footer class="dh-footer" aria-label="Футер Data Heroes">
        <div class="dh-footer-main">
            <div class="dh-footer-container">
                <div class="dh-partners" aria-label="Партнёры и поддержка">
                    <img
                        class="dh-logo-sk"
                        src="@/assets/img/partner-logo/skolkovo.png"
                        alt="Сколково. Участник"
                    />
                    <img
                        class="dh-logo-fsi"
                        src="@/assets/img/partner-logo/fsi.png"
                        alt="Фонд содействия инновациям"
                    />
                </div>

                <nav class="dh-footer-docs" aria-label="Документы">
                    <div class="dh-footer-title">Документы</div>
                    <div class="dh-footer-links">
                        <a href="https://dataheroes.pro/policy-two" target="_blank" rel="noopener noreferrer"
                            >Политика конфиденциальности</a
                        >
                        <a href="https://dataheroes.pro/terms" target="_blank" rel="noopener noreferrer"
                            >Условия использования сервиса</a
                        >
                    </div>
                    <div class="dh-docs-contact" aria-label="Контакты Data Heroes">
                        <div>Почта: info@dataheroes.pro</div>
                        <div>Номер: +7 965 105 71 94</div>
                    </div>
                </nav>

                <div class="dh-company-list" aria-label="Реквизиты">
                    <div class="dh-company">
                        <b>ООО «Дата Хироус Тех»</b>
                        <div>ИНН: 9707044753</div>
                        <div>КПП: 770701001</div>
                        <div>ОГРН: 1257700159628</div>
                    </div>
                    <div class="dh-company">
                        <b>ООО «Дата Хироус»</b>
                        <div>ИНН: 7707452371</div>
                        <div>КПП: 770701001</div>
                        <div>ОГРН: 1217700201058</div>
                    </div>
                </div>

                <div class="dh-address" aria-label="Адрес">
                    <b>Адрес</b>
                    <div class="dh-address-row">127055, Москва, пер. Порядковый, д. 21, помещение 1/Н</div>
                </div>

                <section class="dh-support-card" aria-label="Поддержка">
                    <div class="dh-support-head">
                        <span class="dh-support-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M5 13v-2a7 7 0 0 1 14 0v2"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M6 12H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1v-6Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M18 12h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v-6Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 19h-2.5a1.5 1.5 0 1 1 0-3H15v3Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M18 18c0 1-1 1-3 1"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                />
                            </svg>
                        </span>
                        <div class="dh-support-title">Поддержка</div>
                    </div>
                    <div class="dh-support-actions">
                        <a
                            class="dh-support-btn"
                            href="https://t.me/dataheroes_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            >Telegram</a
                        >
                        <a
                            class="dh-support-btn dh-support-btn--max"
                            href="https://max.ru/id7707452371_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            >MAX</a
                        >
                    </div>
                </section>
            </div>
        </div>

        <div class="dh-footer-bottom">
            <div class="dh-footer-container dh-footer-bottom-inner">
                <span class="dh-copy">© 2026 Data Heroes</span>
                <span class="dh-grant-note"
                    >При поддержке Фондом Содействия Инновациям в рамках федерального проекта «Отечественные
                    решения»</span
                >
            </div>
        </div>

        <div class="dh-mobile-footer" aria-label="Мобильный футер Data Heroes">
            <div class="dh-mobile-top">
                <div class="dh-mobile-partners" aria-label="Партнёры">
                    <img
                        class="dh-logo-sk"
                        src="@/assets/img/partner-logo/skolkovo.png"
                        alt="Сколково. Участник"
                    />
                    <img
                        class="dh-logo-fsi"
                        src="@/assets/img/partner-logo/fsi.png"
                        alt="Фонд содействия инновациям"
                    />
                </div>

                <section class="dh-mobile-support" aria-label="Поддержка">
                    <div class="dh-mobile-support-head">
                        <span class="dh-mobile-support-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M5 13v-2a7 7 0 0 1 14 0v2"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                />
                                <path
                                    d="M6 12H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h1v-6Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M18 12h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1v-6Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M15 19h-2.5a1.5 1.5 0 1 1 0-3H15v3Z"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M18 18c0 1-1 1-3 1"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                />
                            </svg>
                        </span>
                        <div class="dh-mobile-support-title">Поддержка</div>
                    </div>
                    <div class="dh-mobile-support-actions">
                        <a
                            class="dh-mobile-support-btn"
                            href="https://t.me/dataheroes_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            >Telegram</a
                        >
                        <a
                            class="dh-mobile-support-btn dh-mobile-support-btn--max"
                            href="https://max.ru/id7707452371_bot"
                            target="_blank"
                            rel="noopener noreferrer"
                            >MAX</a
                        >
                    </div>
                </section>

                <div class="dh-mobile-accordion">
                    <details class="dh-mobile-details">
                        <summary>
                            <span>Документы и контакты</span>
                            <v-icon size="20" class="dh-mobile-chevron" aria-hidden="true">mdi-chevron-down</v-icon>
                        </summary>
                        <div class="dh-mobile-details-content">
                            <nav class="dh-mobile-doc-links" aria-label="Документы">
                                <a href="https://dataheroes.pro/policy" target="_blank" rel="noopener noreferrer"
                                    >Политика конфиденциальности</a
                                >
                                <a href="https://dataheroes.pro/terms" target="_blank" rel="noopener noreferrer"
                                    >Условия использования сервиса</a
                                >
                            </nav>
                            <div class="dh-mobile-contact">
                                <div>Почта: info@dataheroes.pro</div>
                                <div>Номер: +7 965 105 71 94</div>
                            </div>
                        </div>
                    </details>

                    <details class="dh-mobile-details">
                        <summary>
                            <span>Реквизиты и адрес</span>
                            <v-icon size="20" class="dh-mobile-chevron" aria-hidden="true">mdi-chevron-down</v-icon>
                        </summary>
                        <div class="dh-mobile-details-content">
                            <div class="dh-mobile-company-grid">
                                <div class="dh-mobile-company">
                                    <b>ООО «Дата Хироус Тех»</b>
                                    <div>ИНН: 9707044753</div>
                                    <div>КПП: 770701001</div>
                                    <div>ОГРН: 1257700159628</div>
                                </div>
                                <div class="dh-mobile-company">
                                    <b>ООО «Дата Хироус»</b>
                                    <div>ИНН: 7707452371</div>
                                    <div>КПП: 770701001</div>
                                    <div>ОГРН: 1217700201058</div>
                                </div>
                            </div>
                            <div class="dh-mobile-address">
                                <b>Адрес</b>
                                <div>127055, Москва, пер. Порядковый, д. 21, помещение 1/Н</div>
                            </div>
                        </div>
                    </details>
                </div>
            </div>

            <div class="dh-mobile-bottom">
                <span class="dh-mobile-copy">© 2026 Data Heroes</span>
                <span class="dh-mobile-grant-note"
                    >При поддержке Фондом Содействия Инновациям в рамках федерального проекта «Отечественные
                    решения»</span
                >
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.dh-footer
    display: block
    width: 100%
    margin: 0
    padding: 0
    box-sizing: border-box
    color: #1F2440
    font-family: 'Geologica', sans-serif
    -webkit-font-smoothing: antialiased
    background: #FFFFFF
    border-top: 1px solid #E6E9F0

.dh-footer-main
    display: block
    width: 100%
    box-sizing: border-box
    background: linear-gradient(180deg, #fff 0%, #FBFCFF 100%)

.dh-footer-container
    display: grid
    width: 100%
    max-width: 1200px
    margin: 0 auto
    min-width: 0
    box-sizing: border-box
    grid-template-columns: minmax(0, 150px) minmax(0, 210px) minmax(0, 220px) minmax(0, 1fr) minmax(0, 170px)
    gap: 20px
    padding: 28px 16px

.dh-footer-title
    margin-bottom: 10px
    color: #AAB2C4
    font-size: 10.5px
    font-weight: 900
    letter-spacing: .08em
    text-transform: uppercase

.dh-partners
    display: flex
    flex-direction: column
    align-items: flex-start
    gap: 18px
    min-width: 0

.dh-logo-sk,
.dh-logo-fsi
    max-width: 100%
    height: auto
    display: block
    width: 142px

.dh-footer-docs
    min-width: 0

.dh-footer-links
    display: flex
    flex-direction: column
    gap: 10px
    font-size: 12.5px
    line-height: 1.35

    a
        color: #1F2440
        text-decoration: underline
        text-underline-offset: 3px
        text-decoration-thickness: 1px
        overflow-wrap: anywhere
        word-break: break-word

        &:hover
            color: #525AD5

.dh-docs-contact
    margin-top: 18px
    padding-top: 14px
    border-top: 1px solid #EFF1F6
    color: #7A839A
    font-size: 12.5px
    line-height: 1.48
    display: flex
    flex-direction: column
    gap: 4px
    overflow-wrap: anywhere
    word-break: break-word

.dh-company-list
    display: flex
    flex-direction: column
    gap: 20px
    min-width: 0

.dh-company
    color: #7A839A
    font-size: 12.5px
    line-height: 1.52
    overflow-wrap: anywhere
    word-break: break-word

    b
        display: block
        margin-bottom: 2px
        color: #1A1A2E
        font-size: 12.8px
        font-weight: 800

.dh-address
    min-width: 0
    color: #7A839A
    font-size: 12.5px
    line-height: 1.52

    b
        display: block
        margin-bottom: 6px
        color: #1A1A2E
        font-size: 12.8px
        font-weight: 800

.dh-address-row
    margin-top: 2px
    overflow-wrap: anywhere
    word-break: break-word

.dh-support-card
    width: 100%
    max-width: 170px
    min-width: 0
    box-sizing: border-box
    border: 1px solid #DDE2FF
    border-radius: 18px
    background: linear-gradient(180deg, #F7F8FF 0%, #F1F3FF 100%)
    padding: 14px
    display: flex
    flex-direction: column
    gap: 10px
    align-self: start

.dh-support-head
    display: flex
    align-items: center
    gap: 8px

.dh-support-icon
    width: 28px
    height: 28px
    border-radius: 9px
    display: flex
    align-items: center
    justify-content: center
    background: #fff
    color: $main-new
    border: 1px solid rgba(82, 90, 213, .18)
    flex-shrink: 0

    svg
        width: 17px
        height: 17px

.dh-support-title
    font-size: 13px
    font-weight: 900
    color: #1A1A2E
    letter-spacing: -.01em

.dh-support-actions
    display: flex
    flex-direction: column
    gap: 8px
    width: 100%
    min-width: 0

.dh-support-btn
    width: 100%
    min-width: 0
    min-height: 36px
    display: flex
    align-items: center
    justify-content: center
    padding: 9px 8px
    border-radius: 10px
    background: $main-new
    color: #fff
    font-size: 12px
    font-weight: 900
    text-decoration: none
    box-sizing: border-box
    transition: background .15s

    &:hover
        background: #454CC0
        color: #fff

    &--max
        background: #fff !important
        color: $main-new !important
        border: 1px solid rgba(82, 90, 213, .24)

        &:hover
            background: #F4F5FF !important
            color: #454CC0 !important

.dh-footer-bottom
    width: 100%
    box-sizing: border-box
    border-top: 1px solid #EFF1F6
    background: #FBFCFF

.dh-footer-bottom-inner
    display: flex
    align-items: center
    justify-content: space-between
    gap: 20px
    padding-top: 14px
    padding-bottom: 14px

.dh-copy
    color: #AAB2C4
    font-size: 11.5px
    flex-shrink: 0

.dh-grant-note
    color: #7A839A
    font-size: 10.8px
    line-height: 1.35
    text-align: right
    text-transform: uppercase
    min-width: 0
    overflow-wrap: anywhere
    word-break: break-word

.dh-mobile-footer
    display: none

@media (max-width: 1120px)
    .dh-footer-container
        grid-template-columns: minmax(0, 150px) minmax(0, 210px) minmax(0, 1fr) minmax(0, 170px)

    .dh-company-list
        grid-column: 2 / 3

    .dh-address
        grid-column: 3 / 4

    .dh-support-card
        grid-column: 4 / 5
        grid-row: 1 / 3

@media (max-width: 960px)
    .dh-footer-container
        grid-template-columns: minmax(0, 1fr)
        gap: 22px
        padding: 22px 16px

    .dh-support-card,
    .dh-company-list,
    .dh-address
        grid-column: auto
        grid-row: auto

    .dh-support-card
        max-width: none

    .dh-footer-bottom-inner
        align-items: flex-start
        flex-direction: column
        gap: 8px

    .dh-grant-note
        text-align: left

@media (max-width: 640px)
    .dh-footer-main,
    .dh-footer-bottom
        display: none

    .dh-mobile-footer
        display: block
        background: linear-gradient(180deg, #fff 0%, #FBFCFF 100%)

    .dh-mobile-top
        padding: 16px

    .dh-mobile-partners
        display: flex
        align-items: center
        gap: 18px
        min-height: 52px
        padding-bottom: 14px
        border-bottom: 1px solid #EFF1F6

        .dh-logo-sk
            width: 118px
            flex-shrink: 0

        .dh-logo-fsi
            width: 104px
            flex-shrink: 0

    .dh-mobile-support
        margin-top: 14px
        padding: 14px
        border: 1px solid #DDE2FF
        border-radius: 15px
        background: linear-gradient(180deg, #F7F8FF 0%, #F1F3FF 100%)

    .dh-mobile-support-head
        display: flex
        align-items: center
        gap: 9px
        margin-bottom: 12px

    .dh-mobile-support-icon
        width: 30px
        height: 30px
        display: flex
        align-items: center
        justify-content: center
        flex-shrink: 0
        border: 1px solid rgba(82, 90, 213, .18)
        border-radius: 9px
        background: #fff
        color: $main-new

        svg
            width: 17px
            height: 17px

    .dh-mobile-support-title
        font-size: 14px
        font-weight: 900
        color: #1A1A2E

    .dh-mobile-support-actions
        display: grid
        grid-template-columns: 1fr 1fr
        gap: 8px

    .dh-mobile-support-btn
        min-width: 0
        min-height: 40px
        display: flex
        align-items: center
        justify-content: center
        padding: 9px 10px
        border-radius: 10px
        background: $main-new
        color: #fff
        font-size: 12px
        font-weight: 900
        text-decoration: none
        box-sizing: border-box

        &--max
            border: 1px solid rgba(82, 90, 213, .24)
            background: #fff
            color: $main-new

    .dh-mobile-accordion
        margin-top: 12px
        border: 1px solid #E6E9F0
        border-radius: 14px
        overflow: hidden
        background: #fff

    .dh-mobile-details + .dh-mobile-details
        border-top: 1px solid #EFF1F6

    .dh-mobile-details
        summary
            min-height: 28px
            display: flex
            align-items: center
            justify-content: space-between
            gap: 12px
            padding: 12px 14px
            cursor: pointer
            list-style: none
            color: #1A1A2E
            font-size: 12.5px
            font-weight: 800
            user-select: none

            &::-webkit-details-marker
                display: none

            &::marker
                content: ''

        &[open] summary
            background: #FAFBFD

            .dh-mobile-chevron
                transform: rotate(180deg)

    .dh-mobile-chevron
        color: #AAB2C4 !important
        flex-shrink: 0
        transition: transform .15s

    .dh-mobile-details-content
        padding: 0 14px 14px
        color: #7A839A
        font-size: 12px
        line-height: 1.5

    .dh-mobile-doc-links
        display: flex
        flex-direction: column
        gap: 8px

        a
            color: #1F2440
            text-decoration: underline
            text-underline-offset: 3px

    .dh-mobile-contact
        display: flex
        flex-direction: column
        gap: 4px
        margin-top: 12px
        padding-top: 12px
        border-top: 1px solid #EFF1F6

    .dh-mobile-company-grid
        display: grid
        grid-template-columns: 1fr
        gap: 14px

    .dh-mobile-company b,
    .dh-mobile-address b
        display: block
        margin-bottom: 4px
        color: #1A1A2E
        font-size: 12px
        font-weight: 800

    .dh-mobile-address
        margin-top: 14px
        padding-top: 12px
        border-top: 1px solid #EFF1F6

        div + div
            margin-top: 5px

    .dh-mobile-bottom
        display: flex
        flex-direction: column
        gap: 7px
        padding: 12px 16px 14px
        border-top: 1px solid #EFF1F6
        background: #FBFCFF

    .dh-mobile-copy
        color: #AAB2C4
        font-size: 11px

    .dh-mobile-grant-note
        color: #7A839A
        font-size: 9px
        line-height: 1.4
        text-transform: uppercase
</style>
